import { DecretTertiaireDiagnostic } from '../../../components/tools/DecretTertiaireDiagnostic';
import { AudienceToolHero } from '../../../components/blocks/AudienceToolHero';
import { getAudienceToolContent } from '../../../config/audience-tool-content';
import { BreadcrumbListLd } from '../../../components/seo/jsonld/BreadcrumbList';

const content = getAudienceToolContent('collectivites', 'decret-tertiaire')!;

export default function CollectivitesDecretTertiairePage() {
  return (
    <>
      <AudienceToolHero
        content={content}
        backHref="/collectivites"
        backLabel="Espace collectivités"
        duration="3 min"
      >
        <DecretTertiaireDiagnostic lockedAudience="collectivites" />
      </AudienceToolHero>

      <BreadcrumbListLd
        items={[
          { name: 'Accueil', url: 'https://solutionecofrance.fr/' },
          { name: 'Espace collectivités', url: 'https://solutionecofrance.fr/collectivites' },
          { name: 'Décret Tertiaire', url: 'https://solutionecofrance.fr/collectivites/decret-tertiaire' },
        ]}
      />
    </>
  );
}
